import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';

import { selectIdentityValidation } from 'src/store/selectors/clientSelectors';
import {
  CLEAR_CLIENT_IDENTITY_VALIDATION,
  LOAD_CLIENT_IDENTITY_VALIDATION,
  loadClientIdentityValidation
} from 'src/store/actions/clientActions';
import AlertWithLink from 'src/components/Alert/AlertWithLink/AlertWithLink';
import { Link } from 'react-router-dom';

const ClientValidationAlert = ({ clientId, onWarningStateChange }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientValidation = useSelector(selectIdentityValidation);
  const loading = useSelector(
    isLoadingSelector([LOAD_CLIENT_IDENTITY_VALIDATION.action])
  );
  const success = useSelector(
    successSelector([LOAD_CLIENT_IDENTITY_VALIDATION.action])
  );
  const [showValidationWarning, setShowValidationWarning] = useState(false);

  useEffect(() => {
    setShowValidationWarning(false);
  }, [clientId]);

  useEffect(() => {
    if (clientId) {
      dispatch(loadClientIdentityValidation(clientId));
    }
    return () => {
      dispatch({ type: CLEAR_CLIENT_IDENTITY_VALIDATION });
    };
  }, [clientId, dispatch]);

  useEffect(() => {
    if (!loading && success && clientValidation?.nufiScore <= 70) {
      setShowValidationWarning(true);
    }
  }, [loading, success, clientValidation]);

  useEffect(() => {
    onWarningStateChange?.(showValidationWarning);
  }, [showValidationWarning, onWarningStateChange]);

  if (!showValidationWarning) return null;

  return (
    <AlertWithLink
      severity="warning"
      text={t('ALERTS.IDENTITY_VALIDATION_WARNING')}
      open={showValidationWarning}
      link={
        <Link to={`/clients/detail/${clientId}/identity`}>
          {t('LINKS.VIEW_VALIDATION_DETAILS')}
        </Link>
      }
      handleClose={() => setShowValidationWarning(false)}
    />
  );
};

ClientValidationAlert.propTypes = {
  clientId: PropTypes.string,
  onWarningStateChange: PropTypes.func
};

export default ClientValidationAlert;
